import { BehaviorSubject } from 'rxjs';

import { UserInteractions } from '../system-types';

export const _sessionTimeoutWarningInitialValue = {
  timeoutIn: -1,
};

export const sessionTimeoutWarning = new BehaviorSubject(_sessionTimeoutWarningInitialValue);

export const _userInteractionInitialValue: {
  type: UserInteractions;
  data: {
    event?: Event;
    eventType?: string;
    eventTarget?: HTMLElement;
    eventTargetDataset?: DOMStringMap;
    eventTargetNodeName?: string;
  };
} = {
  type: UserInteractions.NONE,
  data: {},
};

export const userInteraction = new BehaviorSubject(_userInteractionInitialValue);
